module.exports = __webpack_public_path__ + "static/media/button-restart.51eec6c9.png";